
export class Locale {
    public city: string = '';
    public state: string = '';
    public country: string = '';
}

